import React from 'react'

import CustomHelmet from '../components/CustomHelmet'
import Hero from '../components/ProgramOverview/Hero'
import Alumni from '../components/Home/Alumni'
import Apply from '../components/Apply'
import Helmet from 'react-helmet'
import Fellows from '../components/Fellows'
import Quote from '../components/Destination/Quote'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'
import TeamFilter from '../components/TeamFilter'

class TeamPage extends React.Component {
  render() {
    let { data: { page, staffDivision, profiles, fellows } } = this.props
    console.log(staffDivision)

    let filteredDivision = staffDivision.edges.filter( division => {
        if (division.node.title == 'Alumni Moderator' || division.node.title == 'Impact Speaker' || division.node.title == 'Academy Speakers: Spring 2021' || division.node.title == 'Academy Speakers: Summer 2021' || division.node.title == 'Academy Speakers: Fall 2021' || division.node.title == 'Academy Speakers: ALL TIME' || division.node.title == 'Academy Speakers: Spring 2022') {
            return false
        }
        else {
            return true
        }
    })
    let filteredProfiles = profiles.edges.filter( profile => {
        if (profile.node.team[0].title == 'Alumni Moderator' || profile.node.team[0].title == 'Impact Speaker' || profile.node.team[0].title == 'Academy Speakers: Spring 2021' || profile.node.team[0].title == 'Academy Speakers: Summer 2021' || profile.node.team[0].title == 'Academy Speakers: Fall 2021' || profile.node.team[0].title == 'Academy Speakers: ALL TIME' || profile.node.team[0].title == 'Academy Speakers: Spring 2022') {
            return false
        }
        else {
            return true
        }
    })

    const temporarySEOData = {
        keywords: null,
        openGraphDescription: {
            openGraphDescription: "Meet our team working at the crossroads of social entrepreneurship, international education and global development.",
        },
        openGraphImage: null,
        openGraphTitle: "Our Team | Global Citizen Year",
        pageDescription: {
            pageDescription: "Meet our team working at the crossroads of social entrepreneurship, international education and global development."
        },
        pageTitle: "Our Team | Global Citizen Year"
    }

    return (
      <div className="page-team" style={{paddingBottom: '120px', margin: '0 auto'}}>
        <CustomHelmet data={ temporarySEOData } />
        <Hero title="Meet Our Team" />
        <Row className="team-outer-wrap capper">
            <TeamFilter staffDivision={ filteredDivision } profiles={ filteredProfiles } { ...this.props } />
            <div className="strokes" style={{ left: '-120px', transform:'scaleX(-1.0)', top:'75vh' }}>
                <img src="/images/yellow-strokes.png" alt=""/>
            </div>
        </Row>
        <Row className="bg-dark-grey reduced-padding">
          <section>
            <div className="block standard-spacing block-download">
              <div>
                <img src="https://images.ctfassets.net/j91b9gwu8s3q/fMmwEP0R4EYEBDAPYbGPb/8bc162a09d5fe53bfb47807a516bdbcf/DEIA_Report_preview.png" alt="booklet mockup" />
              </div>
              <div>
                <h3 className="boldItal color-white">DOWNLOAD OUR DEIA PROGRESS REPORT</h3>
                <p className="color-white">We are continuously striving to deepen our commitment to diversity, equity, inclusion, and anti-racism. We’re sharing this report openly in an effort to lead out loud and be transparent about what we’re learning, what we’re doing well, and what we can improve.</p>
                <a href="https://downloads.ctfassets.net/j91b9gwu8s3q/3TFzDCU13hSUYmbn02RG36/459fcd6aa98e94b3a5dc2a6bdc5e7c33/Global_Citizen_Year_-_DEIA_Progress_Report.pdf" target="_blank" className="hoverlink white">Download Now</a>
              </div>
            </div>
          </section>
        </Row>
      </div>
    )
  }
}

export default TeamPage

export const query = graphql`
  query TeamPageQuery {
      staffDivision:allContentfulStaffTeam {
          edges {
            node {
              title
            }
          }
        }
        profiles:allContentfulStaffProfile {
          edges {
            node {
              name
              title
              image {
                resize(width:320, height:320) {
                  src
                }
              }
              bio {
                bio
              }
              team {
                title
              }
            }
          }
        }

    page: contentfulHomePage {
      heroText
      heroTitle

      afterHeroTitle
      afterHeroText
      afterHeroItemOneTitle
      afterHeroItemOneText
      afterHeroItemTwoTitle
      afterHeroItemTwoText
      afterHeroItemThreeTitle
      afterHeroItemThreeText
      afterHeroLink {
        text
        link
      }
      issuesTitle
      issuesText
      issuesLink {
        text
        link
      }
      countryCards {
        title
        description
        backgroundImage {
          file {
            url
            fileName
            contentType
          }
          title
        }
        link
      }
      accessTitle
      accessText
			accessLogoList {
        file {
          url
          fileName
          contentType
        }
        title
      }
      testimonialsTitle
      testimonials {
        title
        quote
        featuredMedia {
          file {
            url
            fileName
            contentType
          }
          title
        }
        videoLink
        profileImage {
          file {
            url
            fileName
            contentType
          }
          title
        }
        link {
          text
          link
        }
      }
      alumniCards {
        title
        text {
          text
        }
      }
      alumniTitle
      alumniLink {
        text
        link
      }
      signupTitle
      seoData {
        pageTitle
        pageDescription {
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          openGraphDescription
        }
        openGraphImage {
          file {
            url
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/our-team.js